import { render, staticRenderFns } from "./QuickSnack.vue?vue&type=template&id=721c40ea&"
import script from "./QuickSnack.vue?vue&type=script&lang=ts&"
export * from "./QuickSnack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports